//token-visitante = 'eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc';
//token-adm = 'eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is';

import { Injectable } from "@angular/core";

@Injectable()
export class DataService {
    private SERVER_URL: string;
    private TENANTS: string[];
    private TOKEN: string;
    private GOOGLE_MAP_API: string;
    private LATLNG: any;
    private S3URL: any;
    private COOKIE_NAME: any;
    private CONTAS_DOMAIN: any;

    constructor() {
        console.log(process.env.ENV);
        if (process.env.ENV === 'production') {
            this.setServer('https://frotas-api.geosiap.net/api');
            this.setTenants(["grupoembras", "demo", "teste"]);
            this.setS3('http://geosiap.s3.amazonaws.com/');
            this.setCookieName('production_token');
            this.setContasDomain('https://contas.geosiap.net');
        } else if (process.env.ENV === 'staging') {
            this.setServer('https://frotas-api-beta.geosiap.net/api');
            this.setTenants(["t1", "t2", "t3", "pinda", "teste"]);
            this.setS3('http://geosiap-beta.s3.amazonaws.com/');
            this.setCookieName('production_token');
            this.setContasDomain('https://contas.geosiap.net');
        } else {
            this.setServer('https://frotas-api-beta.geosiap.net/api'); // this.setServer('http://localhost:3000/api');
            this.setTenants(["t1", "t2", "t3", "pinda", "teste"]);
            this.setS3('http://geosiap-beta.s3.amazonaws.com/');
            this.setCookieName('staging_token');
            this.setContasDomain('https://contas.geosiap.net');
        }

        this.setGoogleMapApi("AIzaSyARKrWpAYaGGnxKdgF_Zf35ObKQJw2gbyY");
        this.setCoordinates({lat: -18.7049724, lng: -44.8395315});

        // const url: string = window.location.href;
        // if (url.indexOf('visitante') === -1) {
        //     this.setToken('eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is');
        // } else {
        //     this.setToken('eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc');
        // }
    }

    setToken(item: string) {
        this.TOKEN = item;
    }

    getToken() {
        return this.TOKEN;
    }

    setTenants(item: string[]) {
        this.TENANTS = item;
    }

    getTenants() {
        return this.TENANTS;
    }

    setServer(item: string) {
        this.SERVER_URL = item;
    }

    getServer() {
        return this.SERVER_URL;
    }

    setGoogleMapApi(item: string) {
        this.GOOGLE_MAP_API = item;
    }

    getGoogleMapApi() {
        return this.LATLNG;
    }

    setCoordinates(item: any) {
        this.LATLNG = item;
    }

    getCoordinates() {
        return this.GOOGLE_MAP_API;
    }

    setS3(item: string) {
        this.S3URL = item;
    }

    getS3() {
        return this.S3URL;
    }

    setCookieName(item: string) {
        this.COOKIE_NAME = item;
    }

    getCookieName() {
        return this.COOKIE_NAME;
    }

    setContasDomain(item: string) {
        this.CONTAS_DOMAIN = item;
    }

    getContasDomain() {
        return this.CONTAS_DOMAIN;
    }


}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/services/data.service.ts
 **/